import { useAutoAnimate } from '@formkit/auto-animate/react';
import { TitleRow } from 'components/TitleRow';
import { Nothing } from 'components/Nothing';
import { PerformersItem } from 'ui/PerformersItem';
import styles from './PerformersList.module.scss';
import { ItemsPerformersType } from 'redux/Api/performersWorkSupport/type';

interface PropsType {
  data: ItemsPerformersType[];
}

export const PerformersList = ({ data }: PropsType) => {
  const [parent] = useAutoAnimate({ duration: 300 });

  const dataTitle = ['Исполнитель', 'Телефон', 'Статус'];

  return (
    <div ref={parent} className={styles.root}>
      <TitleRow data={dataTitle} title={'performersList'} />
      {data?.length ? (
        data.map((item) => (
          <div key={item.id}>
            <PerformersItem employed={item} />
          </div>
        ))
      ) : (
        <Nothing style={{ height: '640px' }} title='Ничего не найдено' />
      )}
    </div>
  );
};
